import { Component, input, output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { Button, Badge } from 'excellence-ui';
import { FileResponse } from '../../../../core/clients/omni-core/models';
import { DocumentFilenamePipe } from '../../pipes/document-filename-pipe';
import { DatePipe } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { DocumentFileTypePipe } from '../../pipes/document-file-type.pipe';

@Component({
  selector: 'app-document-lma-card',
  imports: [
    NgIcon,
    Button,
    DocumentFilenamePipe,
    DatePipe,
    TranslocoPipe,
    Badge,
    DocumentFileTypePipe,
  ],
  templateUrl: './document-lma-card.html',
})
export class DocumentLmaCard {
  document = input.required<FileResponse>();

  clickOpen = output();
}
